module.exports = __webpack_public_path__ + "img/rule_template_example.bbfc6578.png";